<template>
  <div>
    <v-card>
      <v-toolbar flat dense v-if="!withoutHeader" >
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-container fluid>
        <slot name="body"></slot>
      </v-container>
    </v-card>
    <br/>
  </div>
</template>

<script>
export default {
  name: "WCardForm",
  props: {
    title: String,
    withoutHeader: Boolean,
  }
}
</script>

<style scoped>

</style>